import actions from './index';
import { BASE_URL } from '../constants/api';

export const ACTIONS = {
  GET_ALL: 'STUDENT_REGION_GET_ALL',
  GET_ALL_SUCCESS: 'STUDENT_REGION_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'STUDENT_REGION_GET_ALL_FAILURE',
};

export const getAll = actions.getAll(() => `${BASE_URL}/students/payout-regions/`, {
  PENDING: ACTIONS.GET_ALL,
  SUCCESS: ACTIONS.GET_ALL_SUCCESS,
  FAILURE: ACTIONS.GET_ALL_FAILURE,
});
